<div class="layout-row align-end gap-2percent container m-b-20">
  <button
    mat-raised-button
    color="primary"
    [routerLink]="['edit']"
    *LOSxHasPermission="'UPDATE_FINANCIALACTIVITYACCOUNT'"
  >
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="deleteFinancialActivityAccount()"
    *LOSxHasPermission="'DELETE_FINANCIALACTIVITYACCOUNT'"
  >
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 header">
          {{ 'labels.inputs.Financial Activity' | translate }}
        </div>

        <div class="flex-50">
          ({{ financialActivityAccount?.financialActivityData.id }})
          {{
            'labels.accounting.financialActivity.' + financialActivityAccount?.financialActivityData.name | translate
          }}
        </div>

        <div class="flex-50 header">
          {{ 'labels.inputs.Account Type' | translate }}
        </div>

        <div class="flex-50">
          {{
            'labels.inputs.accounting.' + financialActivityAccount?.financialActivityData.mappedGLAccountType
              | translate
          }}
        </div>

        <LOSx-gl-account-display
          class="flex-100"
          [glAccount]="financialActivityAccount?.glAccountData"
          [accountTitle]="'Account Name'"
        >
        </LOSx-gl-account-display>
      </div>
    </mat-card-content>

    <mat-card-actions class="layout-row align-center gap-5px responsive-column">
      <button type="button" color="primary" mat-raised-button [routerLink]="['../..']">
        {{ 'labels.buttons.Back' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
